export default "__VITE_ASSET__BduFZdDD__"